import React from 'react';

interface RadioButtonFormProps {
	title: string;
	titleValueMap?: { title: string, value: string }[];
    value : string;
	titleless?: boolean;
	name: string;
	editable?: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		inputStyle: string;
		radioStyle: string;
	};
}

export const RadioButtonForm: React.FC<RadioButtonFormProps> = (props: RadioButtonFormProps) => {

	const { 
		title,
		titleValueMap,
        value,
		titleless = false,
		name,
		editable = true,
		onChange,
		wrapperOption = {
			wrapperStyle: "w-[225px] min-w-[225px] mr-[10px] mb-[5px]",
			titleStyle: "w-[100px] min-w-[100px] text-left",
			inputStyle: "mr-[5px]",
			radioStyle: "w-[75px] min-w-[75px]"
		} 
	} = props;   

	return (
		<div className={`flex h-[20px] ${wrapperOption.wrapperStyle}`}>
			<p className={`${wrapperOption.titleStyle} form-title cursor-pointer mr-[5px] ${titleless ? 'hidden' : ''}`} 
				tabIndex={editable ? 0 : -1}
			>
				{title}
			</p>
			{titleValueMap && titleValueMap.map((mapItem) => (
				<div key={mapItem.value} className={`flex ${wrapperOption.inputStyle}`}>
					<div 
						className={`flex ${wrapperOption.radioStyle} items-center border border-gray-300 rounded-[4px] pl-[5px]
								${editable ? '' : 'bg-gray-100'}
							`}
						onClick={() => {
							if(!editable) return;
							onChange({ target: { name, value: mapItem.value } } as React.ChangeEvent<HTMLInputElement>);
						}}
					>
						<input 
							id={`${name}-${mapItem.value}`}
							type="radio" 
							value={mapItem.value} 
							onChange={onChange} 
							name={name} 
							className=""
							checked={mapItem.value === value}
							disabled={!editable}
						/>
						<label htmlFor={`${name}-${mapItem.value}`} className="pl-[5px]">{mapItem.title}</label>
					</div>
				</div>
			))}
		</div>
	)
}